function NRMetaIcon({ height = '24', width = '24' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_3950_89)">
        <path
          d="M6.89704 4H6.87304L6.84204 6.615H6.86404C8.57904 6.615 9.91004 7.972 12.804 12.861L12.979 13.158L12.991 13.178L14.611 10.74L14.599 10.721C14.245 10.1414 13.879 9.56929 13.501 9.005C13.129 8.44813 12.7371 7.90478 12.326 7.376C10.413 4.932 8.81304 4 6.89704 4Z"
          fill="url(#paint0_linear_3950_89)"
        />
        <path
          d="M6.87301 4C4.95001 4.01 3.24701 5.258 2.02001 7.17C2.01666 7.17566 2.01333 7.18133 2.01001 7.187L4.26401 8.418L4.27501 8.401C4.99301 7.318 5.88501 6.627 6.84301 6.616H6.86401L6.89601 4H6.87301Z"
          fill="url(#paint1_linear_3950_89)"
        />
        <path
          d="M2.01904 7.17004L2.00804 7.18704C1.20004 8.44704 0.598043 9.99504 0.274043 11.664L0.269043 11.686L2.80304 12.286L2.80704 12.264C3.07704 10.797 3.59304 9.43604 4.26304 8.41904L4.27404 8.40204L2.01904 7.17004Z"
          fill="url(#paint2_linear_3950_89)"
        />
        <path
          d="M2.807 12.2639L0.274 11.6639L0.269 11.6859C0.092 12.6039 0.002 13.5369 0 14.4719V14.4949L2.598 14.7279V14.7049C2.58855 13.8867 2.65888 13.0695 2.808 12.2649L2.807 12.2639Z"
          fill="url(#paint3_linear_3950_89)"
        />
        <path
          d="M2.67688 15.537C2.63029 15.2684 2.60388 14.9966 2.59788 14.724V14.702L-0.000121035 14.468V14.492C-0.00303662 15.046 0.0458427 15.5991 0.145879 16.144L2.68088 15.559C2.67953 15.5517 2.67819 15.5444 2.67688 15.537Z"
          fill="url(#paint4_linear_3950_89)"
        />
        <path
          d="M3.27009 16.89C2.98609 16.58 2.78609 16.134 2.68109 15.562L2.67709 15.541L0.14209 16.126L0.14609 16.147C0.33809 17.157 0.71409 17.997 1.25209 18.634L1.26609 18.651L3.28409 16.906C3.27906 16.9007 3.27506 16.8954 3.27009 16.89Z"
          fill="url(#paint5_linear_3950_89)"
        />
        <path
          d="M10.78 9.65405C9.25195 12.0041 8.32595 13.4791 8.32595 13.4791C6.29095 16.6791 5.58695 17.3961 4.45495 17.3961C4.23233 17.4019 4.01109 17.3595 3.80639 17.2718C3.60168 17.1841 3.41835 17.0532 3.26895 16.8881L1.25195 18.6321L1.26595 18.6491C2.00995 19.5181 3.05795 20.0001 4.35595 20.0001C6.31895 20.0001 7.72995 19.0721 10.24 14.6701L12.006 11.5401C11.6142 10.9004 11.206 10.2715 10.78 9.65405Z"
          fill="#0082FB"
        />
        <path
          d="M13.5019 5.94595L13.4859 5.96195C13.0859 6.39195 12.6999 6.86995 12.3259 7.37795C12.7039 7.86095 13.0939 8.40195 13.5009 9.00795C13.9809 8.26495 14.4289 7.66295 14.8679 7.20095L14.8839 7.18495L13.5019 5.94595Z"
          fill="url(#paint6_linear_3950_89)"
        />
        <path
          d="M20.9181 5.713C19.8531 4.633 18.5831 4 17.2251 4C15.7931 4 14.5881 4.787 13.5021 5.944L13.4861 5.96L14.8681 7.2L14.8841 7.183C15.5991 6.436 16.2921 6.063 17.0601 6.063C17.8861 6.063 18.6601 6.453 19.3301 7.138L19.3451 7.154L20.9341 5.729L20.9181 5.713Z"
          fill="#0082FB"
        />
        <path
          d="M23.9981 14.125C23.9381 10.658 22.7281 7.55901 20.9341 5.72901L20.9181 5.71301L19.3301 7.13701L19.3451 7.15301C20.6951 8.54501 21.6221 11.133 21.7061 14.124V14.147H23.9981V14.125Z"
          fill="url(#paint7_linear_3950_89)"
        />
        <path
          d="M23.998 14.15V14.127H21.706V14.149C21.71 14.289 21.712 14.431 21.712 14.573C21.712 15.388 21.591 16.047 21.344 16.523L21.333 16.545L23.041 18.327L23.054 18.307C23.674 17.347 24 16.014 24 14.397C24 14.314 24 14.232 23.998 14.15Z"
          fill="url(#paint8_linear_3950_89)"
        />
        <path
          d="M21.344 16.52L21.333 16.54C21.119 16.942 20.814 17.21 20.416 17.327L21.194 19.789C21.344 19.7383 21.4903 19.6775 21.632 19.607C22.1858 19.3271 22.6567 18.9072 22.998 18.389L23.042 18.324L23.054 18.304L21.344 16.52Z"
          fill="url(#paint9_linear_3950_89)"
        />
        <path
          d="M19.9201 17.3931C19.6581 17.3931 19.4281 17.3541 19.2021 17.2531L18.4041 19.7751C18.8531 19.9281 19.3311 19.9971 19.8641 19.9971C20.3561 19.9971 20.8071 19.9241 21.2161 19.7821L20.4361 17.3201C20.2691 17.3701 20.0961 17.3951 19.9201 17.3931Z"
          fill="url(#paint10_linear_3950_89)"
        />
        <path
          d="M18.3229 16.534L18.3089 16.517L16.4729 18.431L16.4889 18.448C17.1259 19.13 17.7349 19.553 18.4259 19.785L19.2229 17.265C18.9319 17.14 18.6499 16.912 18.3229 16.534Z"
          fill="url(#paint11_linear_3950_89)"
        />
        <path
          d="M18.309 16.515C17.759 15.873 17.077 14.803 16.006 13.075L14.61 10.739L14.599 10.719L12.979 13.157L12.991 13.177L13.98 14.845C14.939 16.455 15.72 17.619 16.473 18.43L16.489 18.446L18.323 16.532C18.3183 16.5263 18.3136 16.5207 18.309 16.515Z"
          fill="url(#paint12_linear_3950_89)"
        />
      </g>
      <defs>
        <linearGradient id="paint0_linear_3950_89" x1="596.486" y1="822.668" x2="114.722" y2="189.353" gradientUnits="userSpaceOnUse">
          <stop offset="0.0006" stopColor="#0867DF" />
          <stop offset="0.4539" stopColor="#0668E1" />
          <stop offset="0.8591" stopColor="#0064E0" />
        </linearGradient>
        <linearGradient id="paint1_linear_3950_89" x1="107.89" y1="339.211" x2="451.638" y2="77.5835" gradientUnits="userSpaceOnUse">
          <stop offset="0.1323" stopColor="#0064DF" />
          <stop offset="0.9988" stopColor="#0064E0" />
        </linearGradient>
        <linearGradient id="paint2_linear_3950_89" x1="153.512" y1="463.144" x2="293.653" y2="109.3" gradientUnits="userSpaceOnUse">
          <stop offset="0.0147" stopColor="#0072EC" />
          <stop offset="0.6881" stopColor="#0064DF" />
        </linearGradient>
        <linearGradient id="paint3_linear_3950_89" x1="132.066" y1="288.006" x2="149.162" y2="60.111" gradientUnits="userSpaceOnUse">
          <stop offset="0.0731" stopColor="#007CF6" />
          <stop offset="0.9943" stopColor="#0072EC" />
        </linearGradient>
        <linearGradient id="paint4_linear_3950_89" x1="139.834" y1="112.18" x2="134.921" y2="75.5056" gradientUnits="userSpaceOnUse">
          <stop offset="0.0731" stopColor="#007FF9" />
          <stop offset="1" stopColor="#007CF6" />
        </linearGradient>
        <linearGradient id="paint5_linear_3950_89" x1="118.561" y1="54.4222" x2="193.558" y2="214.007" gradientUnits="userSpaceOnUse">
          <stop offset="0.0731" stopColor="#007FF9" />
          <stop offset="1" stopColor="#0082FB" />
        </linearGradient>
        <linearGradient id="paint6_linear_3950_89" x1="101.365" y1="216.86" x2="191.807" y2="91.4059" gradientUnits="userSpaceOnUse">
          <stop offset="0.2799" stopColor="#007FF8" />
          <stop offset="0.9141" stopColor="#0082FB" />
        </linearGradient>
        <linearGradient id="paint7_linear_3950_89" x1="223.611" y1="58.299" x2="424.502" y2="799.65" gradientUnits="userSpaceOnUse">
          <stop stopColor="#0082FB" />
          <stop offset="0.9995" stopColor="#0081FA" />
        </linearGradient>
        <linearGradient id="paint8_linear_3950_89" x1="181.5" y1="33.7031" x2="63.6408" y2="272.658" gradientUnits="userSpaceOnUse">
          <stop offset="0.0619" stopColor="#0081FA" />
          <stop offset="1" stopColor="#0080F9" />
        </linearGradient>
        <linearGradient id="paint9_linear_3950_89" x1="100.3" y1="210.437" x2="195.397" y2="145.465" gradientUnits="userSpaceOnUse">
          <stop stopColor="#027AF3" />
          <stop offset="1" stopColor="#0080F9" />
        </linearGradient>
        <linearGradient id="paint10_linear_3950_89" x1="75.8617" y1="154.456" x2="249.303" y2="154.456" gradientUnits="userSpaceOnUse">
          <stop stopColor="#0377EF" />
          <stop offset="0.9994" stopColor="#0279F1" />
        </linearGradient>
        <linearGradient id="paint11_linear_3950_89" x1="127.306" y1="131.871" x2="224.958" y2="189.518" gradientUnits="userSpaceOnUse">
          <stop offset="0.0019" stopColor="#0471E9" />
          <stop offset="1" stopColor="#0377EF" />
        </linearGradient>
        <linearGradient id="paint12_linear_3950_89" x1="185.344" y1="163.088" x2="504.319" y2="565.362" gradientUnits="userSpaceOnUse">
          <stop offset="0.2765" stopColor="#0867DF" />
          <stop offset="1" stopColor="#0471E9" />
        </linearGradient>
        <clipPath id="clip0_3950_89">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default NRMetaIcon;
